(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-forge-curated"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('forge-living-spotlight')) {
  customElements.define('forge-living-spotlight', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.control = this.querySelector('.spotlight-control');
      if (!this.video || !this.control) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.showPhoto = () => {
        this.video.pause();
        this.dataset.state = 'photo';
        this.control.textContent = this.dataset.playLabel;
        this.control.setAttribute('aria-label', this.dataset.playLabel);
        window.clearTimeout(this.loadTimer);
      };
      this.start = () => {
        if (!this.video.src) this.video.src = this.video.dataset.src;
        this.video.muted = true;
        this.video.currentTime = 0;
        window.clearTimeout(this.loadTimer);
        this.loadTimer = window.setTimeout(this.showPhoto, 20000);
        const playback = this.video.play();
        if (playback) playback.catch(this.showPhoto);
      };
      this.video.addEventListener('playing', () => {
        window.clearTimeout(this.loadTimer);
        this.dataset.state = 'playing';
        this.control.textContent = this.dataset.photoLabel;
        this.control.setAttribute('aria-label', this.dataset.photoLabel);
      }, options);
      this.video.addEventListener('ended', this.showPhoto, options);
      this.video.addEventListener('error', this.showPhoto, options);
      this.control.addEventListener('click', () => {
        if (this.dataset.state === 'playing') this.showPhoto();
        else this.start();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.showPhoto();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.showPhoto();
      }, options);
      if (!this.motion.matches && !(navigator.connection && navigator.connection.saveData)) {
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.start();
            }
          }, { threshold: .25 });
          this.observer.observe(this);
        } else this.start();
      }
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      if (this.video) this.video.pause();
      window.clearTimeout(this.loadTimer);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('forge-photo-reviews')) {
  customElements.define('forge-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.reviewAbort) return;
      this.reviewAbort = new AbortController();
      const signal = this.reviewAbort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.interval = Math.max(8000, Number(this.dataset.interval) || 14000);
      this.toggle = this.querySelector('[data-review-toggle]');
      this.slots = Array.from(this.querySelectorAll('[data-review-slot]')).map((el) => ({ el, panes: Array.from(el.querySelectorAll('[data-review-pane]')), index: 0, hover: false, focused: false, timer: null }));
      this.slots.forEach((slot, index) => {
        slot.el.addEventListener('mouseenter', () => { slot.hover = true; }, { signal });
        slot.el.addEventListener('mouseleave', () => { slot.hover = false; }, { signal });
        slot.el.addEventListener('focusin', () => { slot.focused = true; }, { signal });
        slot.el.addEventListener('focusout', (event) => { slot.focused = slot.el.contains(event.relatedTarget); }, { signal });
        slot.el.querySelector('[data-review-prev]')?.addEventListener('click', () => this.show(slot, slot.index - 1), { signal });
        slot.el.querySelector('[data-review-next]')?.addEventListener('click', () => this.show(slot, slot.index + 1), { signal });
        this.schedule(slot, this.interval + index * 2500);
      });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); }, { signal });
      this.motion.addEventListener('change', (event) => { if (event.matches) { this.paused = true; this.updateToggle(); } }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const slot = this.slots.find(item => item.panes.some(pane => pane.dataset.blockId === event.detail.blockId));
        if (!slot) return;
        this.editorPaused = true;
        this.show(slot, slot.panes.findIndex(pane => pane.dataset.blockId === event.detail.blockId));
      }, { signal });
      document.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; }, { signal });
      this.updateToggle();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    show(slot, index) {
      if (!slot.panes.length) return;
      slot.index = (index + slot.panes.length) % slot.panes.length;
      slot.panes.forEach((pane, paneIndex) => {
        const active = paneIndex === slot.index;
        pane.classList.toggle('is-active', active);
        pane.setAttribute('aria-hidden', String(!active));
      });
      const counter = slot.el.querySelector('[data-review-counter]');
      if (counter) counter.textContent = `${slot.index + 1} / ${slot.panes.length}`;
    }
    schedule(slot, delay) {
      if (slot.panes.length < 2) return;
      slot.timer = setTimeout(() => {
        if (!this.paused && !this.editorPaused && !slot.hover && !slot.focused && !document.hidden) this.show(slot, slot.index + 1);
        this.schedule(slot, this.interval);
      }, delay);
    }
    disconnectedCallback() {
      this.slots?.forEach(slot => clearTimeout(slot.timer));
      this.reviewAbort?.abort();
      this.reviewAbort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
